<template>
<div class="container">
  <!-- container -->
  <h1><small>メールアドレス変更完了</small></h1>
  <div class="section">

    <p v-bind:class="alert_style" ref="message">{{ result_message }}</p>

  </div>
  <p class="text-right mt-5">
    <router-link to="/login">ログイン画面へ</router-link>
  </p>
</div>
</template>

<script>
  import auth from 'auth'
  import api from 'api'
  export default {
    data () {
      return {
        result_message: '',
        alert_style: 'alert alert-info'
      }
    },
    created () {
      api.changedEmail(this, this.$route.params.token).then(response => {
        this.result_message = response.message
        auth.logout()
      }).catch(err => {
        this.result_message = err.body.message
        this.alert_style = 'alert alert-danger'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// EditedEmail.vue?69bc2d32